export const scrollToTop = () => {
  const element = document.getElementById('main-app-content-window');
  if (!element) return;
  element.scrollTo(0, 0);
};
